export interface AppraisalMediaUploadDTO {
  appraisalMediaId?: string;
  vehicleId: string;
  appraisalId: string;
  appraisalItemId: string;
  mediaType: number;
  position?: number;
}
